angular.module('ui.order.orderDetailedRouteContainer', [])

    .config(function ($stateProvider) {

        $stateProvider.state('client.order', {
            url: '/order?orderId&orderItemId',
            templateUrl: 'app/ui/order/orderDetailedView/orderDetailedRouteContainer/orderDetailedRouteContainer.html',
            data: {pageTitle: 'OrderManager: Order'},
            controller: 'OrderDetailedRouteContainerController',
            controllerAs: 'OrderDetailedRouteContainerController'
        });

    })

    .controller('OrderDetailedRouteContainerController', function ($scope, $state, $stateParams, gettextCatalog, toastr) {

        if (!$stateParams.orderId && !$stateParams.orderItemId) {
            toastr.warning(gettextCatalog.getString("Order was not specified"));
            $state.go('client.orders');
        }

        $scope.orderId = $stateParams.orderId;
        $scope.orderItemId = $stateParams.orderItemId;

    })
;